<template>
  <div>
    <v-layout row wrap>
      <v-flex md8>
        <p class="headline mt-2">
          Consumo
        </p>
      </v-flex>
      <v-flex md2 pr-3 mb-3>
        <v-btn block class=" ma-0 h-100" @click="generateReport">
          <v-icon small>fas fa-download</v-icon>
        </v-btn>
      </v-flex>
      <v-flex md2 mb-3>
        <v-menu
          ref="fromPicker"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="filters.date"
          transition="scale-transition"
          min-width="290px"
          lazy
          offset-y
          full-width>
          <v-text-field
            slot="activator"
            :value="formatDate(filters.date, 'YYYY-MM', 'MM/YYYY')"
            class="k-orange-linear-text"
            prepend-icon="event"
            readonly
            solo>
          </v-text-field>
          <v-date-picker
            v-model="filters.date"
            @input="$refs.fromPicker.save(filters.date)"
            locale="es"
            type="month"
            color="k-orange-linear">
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex md12>
        <v-card class="mb-4">
          <v-card-text v-if="consumption.Fijo || consumption[2] || consumption[1]">
            <v-list class="mr-5">
              <v-subheader class="f1-5em ml-1 mb-1" v-if="consumption.Fijo">
                <v-layout row wrap>
                  <v-flex xs12>
                    {{consumption.Fijo[0].descrip}}
                  </v-flex>
                </v-layout>
              </v-subheader>
              <v-list-tile class="ml-5 x-borders t-borders" v-if="consumption.Fijo">
                <v-layout row wrap class="f0-9em">
                  <v-flex md3 class="grey-t">
                    Descripción
                  </v-flex>
                  <v-flex md3 class="pl-4 grey-t">
                    Cantidad
                  </v-flex>
                  <v-flex md3 class="pl-4 grey-t">
                    Costo Unitario
                  </v-flex>
                  <v-flex md3 class="text-xs-right grey-t">
                    Monto
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile class="a-borders ml-5" v-if="consumption.Fijo">
                <v-layout row wrap class="f0-9em">
                  <v-flex md3>
                    {{consumption.Fijo[0].descrip}}
                  </v-flex>
                  <v-flex md3 class="pl-4">
                    {{new Intl.NumberFormat('es-VE').format(consumption.Fijo[0].quantity)}}
                  </v-flex>
                  <v-flex md3 class="pl-4">
                    $ {{new Intl.NumberFormat('es-VE').format(consumption.Fijo[0].fee)}}
                  </v-flex>
                  <v-flex md3 class="text-xs-right">
                    $ {{new Intl.NumberFormat('es-VE').format(consumption.Fijo[0].amount)}}
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-subheader class="f1-5em ml-1 mt-3 mb-1">Consumo de Gestión</v-subheader>
              <template v-if="consumption[1]">
                <template v-for="(key, i) in Object.keys(lives)">
                  <v-subheader class="f1-5em ml-4 mb-1" :key="`header-lives-${key}-${i}`">
                    <v-layout row wrap>
                      <v-flex xs12>
                        {{key.toUpperCase()}}
                      </v-flex>
                    </v-layout>
                  </v-subheader>
                  <v-list-tile class="ml-5 a-borders" :key="`values-lives-${key}-${i}`">
                    <v-layout row wrap class="f0-9em">
                      <v-flex md3 class="grey-t">
                        Descripción
                      </v-flex>
                      <v-flex md3 class="pl-4 grey-t">
                        Cantidad
                      </v-flex>
                      <v-flex md3 class="pl-4 grey-t">
                        Costo Unitario
                      </v-flex>
                      <v-flex md3 class="text-xs-right grey-t">
                        Monto
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                  <v-list-tile :class="{'x-borders ml-5 t-borders': i > 0, 'x-borders ml-5': i === 0}" v-for="(consumption, i) in lives[key]" :key="`lives-${key}-${i}`">
                    <v-layout row wrap class="f0-9em">
                      <v-flex md3>
                        {{consumption.descrip !== 'human' ? consumption.descrip.toUpperCase() : 'CALL CENTER'}}
                      </v-flex>
                      <v-flex md3 class="pl-4">
                        {{new Intl.NumberFormat('es-VE').format(consumption.quantity)}}
                      </v-flex>
                      <v-flex md3 class="pl-4">
                        $ {{new Intl.NumberFormat('es-VE').format(consumption.fee)}}
                      </v-flex>
                      <v-flex md3 class="text-xs-right">
                        $ {{new Intl.NumberFormat('es-VE').format(consumption.amount)}}
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                  <v-list-tile class="a-borders ml-5" :key="`total-lives-${key}-${i}`">
                    <v-layout row wrap class="f0-9em">
                      <v-flex md3>
                        <strong>Total</strong>
                      </v-flex>
                      <v-flex md3 class="pl-4">
                        {{new Intl.NumberFormat('es-VE').format(calculateTotalAmount(lives[key], 'quantity'))}}
                      </v-flex>
                      <v-flex md3 class="pl-4">
                        
                      </v-flex>
                      <v-flex md3 class="text-xs-right">
                        $ {{new Intl.NumberFormat('es-VE').format(calculateTotalAmount(lives[key], 'amount'))}}
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                </template>
              </template>
              <template v-else>
                <v-list-tile>
                  <v-layout row wrap>
                    <v-flex md12 class="text-xs-center">
                      No se encontraron resultados
                    </v-flex>
                  </v-layout>
                </v-list-tile>
              </template>
              <v-subheader class="f1-5em ml-1 mt-3 mb-1">Consumo de Campañas</v-subheader>
              <template v-if="consumption[2]">
                <template v-for="(key, i) in Object.keys(campaigns)">
                  <v-subheader class="f1-5em ml-4 mb-1" :key="`header-campaigns-${key}-${i}`">
                    <v-layout row wrap>
                      <v-flex xs12>
                        {{key.toUpperCase()}}
                      </v-flex>
                    </v-layout>
                  </v-subheader>
                  <v-list-tile class="ml-5 a-borders" :key="`values-campaigns-${key}-${i}`">
                    <v-layout row wrap class="f0-9em">
                      <v-flex md3 class="grey-t">
                        Descripción
                      </v-flex>
                      <v-flex md3 class="pl-4 grey-t">
                        Cantidad
                      </v-flex>
                      <v-flex md3 class="pl-4 grey-t">
                        Costo Unitario
                      </v-flex>
                      <v-flex md3 class="text-xs-right grey-t">
                        Monto
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                  <v-list-tile :class="{'x-borders ml-5 t-borders': i > 0, 'x-borders ml-5': i === 0}" v-for="(consumption, i) in campaigns[key]" :key="`campaigns-${key}-${i}`">
                    <v-layout row wrap class="f0-9em">
                      <v-flex md3>
                        {{consumption.descrip !== 'human' ? consumption.descrip.toUpperCase() : 'CALL CENTER'}}
                      </v-flex>
                      <v-flex md3 class="pl-4">
                        {{new Intl.NumberFormat('es-VE').format(consumption.quantity)}}
                      </v-flex>
                      <v-flex md3 class="pl-4">
                        $ {{new Intl.NumberFormat('es-VE').format(consumption.fee)}}
                      </v-flex>
                      <v-flex md3 class="text-xs-right">
                        $ {{new Intl.NumberFormat('es-VE').format(consumption.amount)}}
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                  <v-list-tile class="a-borders ml-5" :key="`total-campaigns-${key}-${i}`">
                    <v-layout row wrap class="f0-9em">
                      <v-flex md3>
                        <strong>Total</strong>
                      </v-flex>
                      <v-flex md3 class="pl-4">
                        {{new Intl.NumberFormat('es-VE').format(calculateTotalAmount(campaigns[key], 'quantity'))}}
                      </v-flex>
                      <v-flex md3 class="pl-4">
                        
                      </v-flex>
                      <v-flex md3 class="text-xs-right">
                        $ {{new Intl.NumberFormat('es-VE').format(calculateTotalAmount(campaigns[key], 'amount'))}}
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                </template>
              </template>
              <template v-else>
                <v-list-tile>
                  <v-layout row wrap>
                    <v-flex md12 class="text-xs-center">
                      No se encontraron resultados
                    </v-flex>
                  </v-layout>
                </v-list-tile>
              </template>
              <v-subheader class="f1-5em ml-1 mt-3 mb-1">
                <v-layout row wrap>
                  <v-flex xs6>
                    Monto Total
                  </v-flex>
                  <v-flex xs6 text-xs-right>
                    {{new Intl.NumberFormat('es-VE').format((consumptionCampaignsTotalAmount + consumptionNormalTotalAmount) + parseFloat(consumption.Fijo ? consumption.Fijo[0].amount : 0))}}
                  </v-flex>
                </v-layout>
              </v-subheader>
            </v-list>
          </v-card-text>
          <v-card-text v-else>
            <v-layout justify-center align-center>
              <v-flex xs12 text-xs-center class="f1-5em">
                No se encontraron resultados
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import formatDateMixin from '@/mixins/formatDate';

const qs = require('qs');

export default {
  mixins: [
    formatDateMixin,
  ],
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      consumption: {},
      consumptionNormal: [],
      consumptionCampaigns: [],
      icons: {
        ivr: 'phone',
        sms: 'comments',
        email: 'envelope',
        bot: 'robot',
        human: 'user',
        'En Proceso': 'clock',
        Compromiso: 'calendar-check',
        Gestionado: 'check',
        'Saldo bajo': 'level-down-alt',
        'Sin contacto digital': 'bell-slash',
        'Sin contacto humano': 'user-times',
      },
      filters: {
        dateType: 'month',
        date: moment().format('YYYY-MM'),
      },
    };
  },
  created() {
    this.getReport();
  },
  computed: {
    /* eslint-disable */
    consumptionNormalTotal() {
      let total = 0;
      if (this.consumption[1]) {
        total = this.calculateTotalAmount(this.consumption[1], 'quantity');
      }
      return total;
    },
    consumptionNormalTotalAmount() {
      let total = 0;
      if (this.consumption[1]) {
        total = this.calculateTotalAmount(this.consumption[1], 'amount');
      }
      return total;
    },
    consumptionCampaignsTotal() {
      let total = 0;
      if (this.consumption[2]) {
        total = this.calculateTotalAmount(this.consumption[2], 'quantity');
      }
      return total;
    },
    consumptionCampaignsTotalAmount() {
      let total = 0;
      if (this.consumption[2]) {
        total = this.calculateTotalAmount(this.consumption[2], 'amount');
      }
      return total;
    },
    lives() {
      let lives = _.mapValues(_.groupBy(this.consumption[1], 'channel'),
                          clist => clist.map(item => _.omit(item, 'channel')));
      return lives;
    },
    campaigns() {
      let campaigns = _.mapValues(_.groupBy(this.consumption[2], 'channel'),
                          clist => clist.map(item => _.omit(item, 'channel')));
      return campaigns;
    },
    /* eslint-enable */
  },
  methods: {
    /* eslint-disable */
    getReport() {
      this.axios.get(`/company_invoices?${qs.stringify(this.filters)}`).then((response) => {
        response.data = response.data.filter(item => item.type != 3);
        this.consumption = _.mapValues(_.groupBy(response.data, 'type'),
                          clist => clist.map(item => _.omit(item, 'type')));
      });
    },
    generateReport() {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            ...this.filters,
            less_type: 3,
            filename: 'Reporte de consumo',
          },
          functionName: 'managementTotal',
        },
      });
    },
    calculateTotalAmount(array, column) {
      let total = 0;
      if (array.length > 0) {
        array.forEach((consumption) => {
          total += parseFloat(consumption[column]);
        });
      }
      return total;
    },
    clearFilters() {
      Object.keys(this.filters).forEach((key) => {
        if (key !== 'date' && key !== 'report') {
          this.filters[key] = false;
        } else {
          // eslint-disable-next-line
          if (key !== 'report') this.filters[key] = moment().format('YYYY-MM-DD');
        }
      });
    },
  },
  watch: {
    'filters.date'(val) { // eslint-disable-line
      this.getReport();
    },
  },
};
</script>

<style scoped>
.grey-t {
  color: rgba(0,0,0,.54);
  font-weight: 700;
}

.customer-status--scrollbar {
  max-height: 150px;
  min-height: 150px;
}

.customer-status-none--scrollbar {
  max-height: 255px;
  min-height: 255px;
}

.hovereable:hover {
  cursor:pointer;
  background: rgba(0, 0, 0, .05) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/consumption/ConsumptionTable.vue